export default "__VITE_ASSET__DpaSCEMW__"